import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import i18next from 'i18next';

import ButtonHoverAnimation from 'components/ButtonHoverAnimation';

import styles from './styles.module.scss';

const SeeAllButton = ({ seeAllUrl, seeAllText }) => {
  if (!seeAllUrl) {
    return null;
  }

  const seeAllTextTest = seeAllText || i18next.t('See All');

  return (
    <div className={classNames(styles.buttonWrapper, 'w-100 df justify-center')}>
      <ButtonHoverAnimation
        size="normal"
        type="link"
        url={seeAllUrl}
        additionalClasses="teaseList__seeAllButton"
        title={seeAllTextTest}
      />
    </div>
  );
};

SeeAllButton.propTypes = {
  seeAllUrl: PropTypes.string,
  seeAllText: PropTypes.string,
};

SeeAllButton.defaultProps = {
  seeAllUrl: null,
  seeAllText: null,
};

export default SeeAllButton;
